import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import "bootstrap-icons/font/bootstrap-icons.css";
import { useDocumentUpload } from "hooks/useDocumentUpload";
import { useParams } from "react-router-dom";
import EditDocModal from "./EditDocModal";
import ValidateFile from "utils/ValidateFile";
import { toast } from "react-toastify";

const DetailCard = ({ title, iconClass, bgColor, userId }) => {
  const[isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedEditFile, setSelectedEditFile] = useState(null);
  const dropdownRef = useRef(null);
  const fileInputRef = useRef(null);
  const params = useParams();
  const idFromUrl = params?.id;
  const { handleViewFile, handleFileSelect } = useDocumentUpload({ candidateId: userId });

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  
  const handleEditClick = () => {
    console.log("file ref:", fileInputRef);
    fileInputRef.current.click();
  }

  const onFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    console.log("file selected:", file);

    const allowedFormats = validationRules[title.toLowerCase()] || validationRules.default;
    const validationResult = ValidateFile(file, allowedFormats);

    if (validationResult !== true) {
      toast.error(validationResult, { className: "toast-error-custom", autoClose: 5000, });
      e.target.value = "";
      return;
    }

    setSelectedEditFile(file);
    handleFileSelect(title, file);
    e.target.value = "";
  }

  const fileAcceptMapping = {
    offerletter: ".pdf",
    aadhaarcard: ".pdf, .jpeg",
    pancard: ".jpg, .jpeg",
    passbookfrontimage: ".jpg, .jpeg",
    cancelledcheque: ".jpg, .jpeg",
    default: ".pdf, .doc, .docx, .jpg, .jpeg, .png"
  };
  const currentAcceptValue = fileAcceptMapping[title.toLowerCase()] || fileAcceptMapping.default;

  const validationRules = {
    offerletter: ['application/pdf'],
    aadhaarcard: ['application/pdf', 'image/jpeg', 'image/jpg'],
    pancard: ['image/jpeg', 'image/jpg'],
    passbookfrontimage: ['image/jpeg', 'image/jpg'],
    cancelledcheque: ['image/jpeg', 'image/jpg'],
    default: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
  };

return (
    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
      <div
        className={`detail-card ${bgColor} shadow-sm d-flex flex-column justify-content-between p-3`}
        style={{  height: "100%" }}  >
        {/* Top Section */}
        <div className="d-flex align-items-center justify-content-center mb-3 text-center">
          <i className={`bi ${iconClass} me-2 card-icon`}></i>
          <h5 className="card-title text-uppercase mb-0"
            style={{ 
              fontSize: "14px", wordBreak: "break-word",  overflowWrap: "anywhere", lineHeight: "1.2"  }}  >
            {title}</h5>
        </div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept={currentAcceptValue}
          onChange={onFileChange}
        />
        {/* Dropdown Section */}
        <div className="dropdown text-end d-flex justify-content-center mt-auto" ref={dropdownRef}>
          {idFromUrl ? (
            <button className="view-details-btn" onClick={toggleDropdown}>
              <i className="bi bi-chevron-down me-1"></i> Actions
            </button>
          ) : (
            <button className="view-details-btn"
              onClick={() => {
                handleViewFile(title);
              }}> view
            </button>
          )
          }

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <ul
              className="custom-dropdown-menu"
               style={{
                position: "absolute",
                right: "-5px",
                bottom: "-15px",
                zIndex: 10,
                listStyle: "none",
                padding: 0,
                margin: 0,
                background: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                borderRadius: "6px",
              }}
            >
              <li>
                <button
                  className="dropdown-item-btn w-100 text-start"
                  onClick={() => {
                    setIsDropdownOpen(false);
                    handleViewFile(title);
                  }}
                >
                  <i className="bi bi-eye me-2"></i> View
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item-btn w-100 text-start"
                  onClick={() => {
                    setIsDropdownOpen(false);
                    handleEditClick();
                  }}
                >
                  <i className="bi bi-pencil me-2"></i> Edit
                </button>
              </li>
            </ul>
          )}
        </div>

         {/* Optional stripe */}
        <div className="vertical-stripe"></div>
      </div> 
      {selectedEditFile && (
        <EditDocModal
          onHide={() => setSelectedEditFile(null)}
          title={title}
          file={selectedEditFile}
          userId={userId}
        />
      )
      }
    </div>
  );
};

DetailCard.propTypes = {
  title: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
  bgColor: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DetailCard;
